import React, { Fragment } from 'react';
import { concat, filter, includes } from 'lodash';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import ButtonList from '../../../../../components/ButtonList';
import { setQuickToDate } from '../../../../../lib/common';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CheckBox from '../../../../../components/input/CheckBox';
import {
  DATE_FORMAT,
  QUICK_DATE_SELECT_BUTTON_TARGET,
  SEARCH_PERIOD_BUTTON_ALL_TYPE,
} from '../../../../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL,
  ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/order/models';
import {
  ORDER_SEARCH_PERIOD_BUTTON_LIST,
  SEARCH_ORDER_EXCHANGE_STATUS_CHECK_BOX_LIST,
  SEARCH_ORDER_MANAGER_CHECK_BOX_LIST,
} from '../../../../../constants/service/app/orderConstants';
import './OrderExchangeListSearchBox.scss';

const OrderExchangeListSearchBox = (props) => {
  const { setData, getList, searchData } = props;
  const { exchangeRequestDate, orderExchangeStatusList, exchangeAcceptManagerList } = searchData;

  return (
    <SearchBox
      className="order-exchange-list-search-box"
      onSearch={() => {
        /**
         * 날짜 선택 빠른 키 값이 전체가 아닌 경우에만 기간을 서버로 전송한다.
         * 날짜 선택이 전체인 경우 => quickDateIndex = -1
         */
        getList({
          searchOption: {
            /**
             *  교환 요청 일시
             */
            exchangeRequestDate:
              exchangeRequestDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? exchangeRequestDate.period : null,
            /**
             *  주문 교환 상태 리스트
             */
            orderExchangeStatusList,
            /**
             *  교환 접수자 리스트
             */
            exchangeAcceptManagerList,
          },
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*교환 요청 일시*/}
      <BaseForm
        label="교환 요청 일시"
        content={
          <div className="quick-date-picker">
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={exchangeRequestDate.quickDateIndex}
              list={ORDER_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setData({
                  path: ['exchangeRequestDate'],
                  value: setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: exchangeRequestDate.period,
                  }),
                })
              }
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={exchangeRequestDate.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) =>
                setData({
                  path: ['exchangeRequestDate'],
                  value: setQuickToDate({
                    period,
                  }),
                })
              }
            />
          </div>
        }
      />

      {/*교환 상태*/}
      <BaseForm
        label="교환 상태"
        content={
          <Fragment>
            {SEARCH_ORDER_EXCHANGE_STATUS_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(orderExchangeStatusList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['orderExchangeStatusList'],
                    value: checked
                      ? concat(orderExchangeStatusList, item.id)
                      : filter(orderExchangeStatusList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      {/*교환 접수자*/}
      <BaseForm
        label="교환 접수자"
        content={
          <Fragment>
            {SEARCH_ORDER_MANAGER_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(exchangeAcceptManagerList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['exchangeAcceptManagerList'],
                    value: checked
                      ? concat(exchangeAcceptManagerList, item.id)
                      : filter(exchangeAcceptManagerList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />
    </SearchBox>
  );
};

export default OrderExchangeListSearchBox;
